import { getDefaultConfig } from '@utils/configUtils';

import { BaseRequestParameters, makePostWithParameters, axiosGet } from './api';
import { captureException } from './sentryService';

export type PSP = 'BRAINTREE' | 'ADYEN';
export type BaseCreditCardRequestParamsPM = 'CREDIT_CARD' | 'BANCONTACT';

export interface BaseCreditCardRequestParameters extends BaseRequestParameters {
  psp: PSP;
  paymentMethod: BaseCreditCardRequestParamsPM;
}

export interface SingleCreditCardRequestParameters extends BaseCreditCardRequestParameters {
  creditCardIdentifier: string;
  paymentMethod: BaseCreditCardRequestParamsPM;
}

export const selectCreditCard = makePostWithParameters<SingleCreditCardRequestParameters, boolean>(
  '/checkout/editpayment/selectZppCreditCard',
);

export const deleteCreditCard = makePostWithParameters<
  SingleCreditCardRequestParameters,
  string | null
>('/checkout/editpayment/deleteZppCreditCard');

export const deleteAllCreditCards = makePostWithParameters<
  BaseCreditCardRequestParameters,
  boolean
>('/checkout/editpayment/deleteAllZppCreditCards');

/**
 * Fetches the favorite (saved) credit card details for a customer.
 *
 * @param customerId - Unique identifier of the customer.
 * @param siteId - Identifier of the site.
 * @param psp - Payment service provider ('BRAINTREE' or 'ADYEN').
 * @param keycloakToken -  keycloak authentication token.
 * @returns The details of the customer's favorite saved credit card.
 */
export const fetchFavoriteCreditCardNonce = async (
  siteId: string,
  keycloakToken: string,
): Promise<string> => {
  const { zppApiBaseUrl } = getDefaultConfig();
  try {
    const headers = keycloakToken ? { Authorization: `Bearer ${keycloakToken}` } : undefined;

    const response = await axiosGet(
      `${zppApiBaseUrl}/braintree/credit-card-with-nonce?siteId=${siteId}`,
      undefined,
      headers,
    );
    return response.data.nonce;
  } catch (error) {
    throw captureException({ error });
  }
};
